/**
 * Regras puras de quem pode entrar no SICOP — sem `import.meta.env`, para
 * poderem ser testadas (a fiação com as variáveis de ambiente fica em
 * `src/auth/config.ts`).
 */

export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** Parte depois do `@`, ou string vazia quando o e-mail é malformado. */
export function emailDomain(email: string): string {
  const normalized = normalizeEmail(email);
  const at = normalized.lastIndexOf('@');
  // Sem `@`, ou com o `@` na ponta, não há domínio para comparar.
  if (at <= 0 || at === normalized.length - 1) return '';
  return normalized.slice(at + 1);
}

/**
 * O domínio da conta não é conferido: quem decide que contas entram é o
 * Google, pela configuração do Client ID. A allowlist é um recorte opcional —
 * vazia, qualquer conta que o Google deixou entrar passa; preenchida, só as
 * contas listadas.
 */
export function isEmailAllowedBy(email: string, allowedEmails: readonly string[]): boolean {
  if (allowedEmails.length === 0) return true;
  return allowedEmails.map(normalizeEmail).includes(normalizeEmail(email));
}
